<template>
    <div class="bg-gray-900">
        <div class="mx-auto">
            <input type="text" v-model="search" placeholder="Search yourself or a classmate"
                class="mb-0 mt-2 ml-4 p-2 w-6/12 rounded-md"
            />
        </div>
        <div class="mx-auto grid lg:grid-cols-2 grid-cols-1 justify-center">
            <template v-for="student in filteredStudents">
                <app-profile class="" :student="student" :key="student.id"></app-profile>
            </template>
        </div>
    </div>
</template>

<script>
import Profile from '../Profile'
import students from '../../../data/students'

export default {
    name: 'MultipleProfiles',
    data() {
        return {
            search: "",
            students: students.students
        }
    },
    components: {
        'app-profile': Profile
    },
    computed:{
        filteredStudents(){
            let x = this.students.filter(student => 
            student.fullname.toLowerCase().includes(this.search.toLowerCase())
            /* || student.nicknames ? student.map(nickname => nickname.toLowerCase()).includes(this.search.toLowerCase()):true */)
           return x.sort(() => Math.random() - 0.5) //shuffling
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/profiles/multiple/Container.vue